module.exports = __webpack_public_path__ + "static/img/0018.e098986d.png";